import { TemplateForm } from "@/components/templates/TemplateForm";
import { useParams } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { templatesWithFieldsQuery } from "@/integrations/supabase/templateEditor";
import { TemplateWithFieldsProvider } from "@/providers/TemplateProvider";

const TemplateEditor = () => {
  const { templateId } = useParams();

  // Fetch template data if editing with expanded query to include branching logic and rule sets
  const { data: template, isLoading } = useQuery({
    queryKey: ["template", templateId],
    queryFn: async () => {
      if (!templateId) return null;

      console.log("Fetching template data for ID:", templateId);

      const { data, error } = await templatesWithFieldsQuery
        .eq("id", templateId)
        .select(
          `
          *,
          template_fields (
            id,
            field_id,
            order_index,
            is_visible,
            field:fields (
              id,
              name,
              type,
              primary_dataset_id,
              filter_id
            ),
            template_field_filters (
              id,
              filter_id,
              is_secondary
            ),
            template_field_branching (
              id,
              condition_field_id,
              condition_value,
              datapoint_id,
              datapoint:datapoints (
                id,
                name,
                smart_tags (
                  tag_value
                )
              )
            ),
            rule_sets:template_field_rule_sets (
              id,
              name,
              description,
              rules:template_field_rules (
                id,
                field_id,
                datapoint_id,
                operator,
                datapoint:datapoints (
                  id,
                  name
                )
              )
            )
          )
        `,
        )
        .single();

      if (error) {
        console.error("Error fetching template:", error);
        throw error;
      }

      console.log("Template data loaded:", data);
      console.log("Template fields found:", data.template_fields.length);
      console.log(
        "Template field filters:",
        data.template_fields.map((tf) => ({
          fieldName: tf.field?.name,
          filters: tf.template_field_filters,
        })),
      );

      return data;
    },
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Template Editor</h1>
        <p className="text-muted-foreground">
          {templateId && !isLoading ? `Edit template: ${template?.name || ""}` : "Create a new template."}
        </p>
      </div>
      {templateId && (
        <TemplateWithFieldsProvider templateId={templateId}>
          <TemplateForm />
        </TemplateWithFieldsProvider>
      )}
    </div>
  );
};

export default TemplateEditor;
